// Animated counter for metric stats
document.addEventListener("DOMContentLoaded", function () {
  // Configuration
  const ANIMATION_DURATION = 2000; // Duration in milliseconds (2 seconds)
  const ANIMATION_START_PERCENTAGE = 0.75; // Start animation at 75% of target value (0.0 to 1.0)
  const INTERSECTION_THRESHOLD = 0.3; // Trigger animation when 30% visible
  const INTERSECTION_ROOT_MARGIN = "0px 0px -100px 0px"; // Offset for triggering

  const metricsSection = document.querySelector(".metrics-section");
  if (!metricsSection) {
    return;
  }

  const statValues = document.querySelectorAll(".stat__value");
  if (statValues.length === 0) {
    return;
  }

  // Parse stat value (e.g., "3M+" -> {number: 3, suffix: "M", plus: true})
  function parseStatValue(text) {
    const match = text.match(/^([\d.]+)([KMB])?(\+)?$/);
    if (!match) {
      return null;
    }

    const number = parseFloat(match[1]);
    const suffix = match[2] || "";
    const hasPlus = match[3] === "+";

    // Convert to actual number for animation
    let multiplier = 1;
    if (suffix === "K") {
      multiplier = 1000;
    }
    if (suffix === "M") {
      multiplier = 1000000;
    }
    if (suffix === "B") {
      multiplier = 1000000000;
    }

    return {
      target: number * multiplier,
      displayNumber: number,
      suffix,
      hasPlus,
      original: text,
    };
  }

  // Format number for display during animation
  function formatNumber(value, suffix, hasPlus) {
    let displayValue;

    if (suffix === "K") {
      displayValue = (value / 1000).toFixed(1);
      if (displayValue.endsWith(".0")) {
        displayValue = displayValue.slice(0, -2);
      }
    } else if (suffix === "M") {
      displayValue = (value / 1000000).toFixed(1);
      if (displayValue.endsWith(".0")) {
        displayValue = displayValue.slice(0, -2);
      }
    } else if (suffix === "B") {
      displayValue = (value / 1000000000).toFixed(1);
      if (displayValue.endsWith(".0")) {
        displayValue = displayValue.slice(0, -2);
      }
    } else {
      // No suffix, show as integer
      displayValue = Math.floor(value).toLocaleString();
    }

    return displayValue + suffix + (hasPlus ? "+" : "");
  }

  // Animate a single stat value
  function animateStat(statElement, parsed) {
    const startTime = performance.now();
    const startValue = parsed.target * ANIMATION_START_PERCENTAGE;

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / ANIMATION_DURATION, 1);

      // Easing function (ease-out) - slows down more at the end
      // Using a stronger ease-out curve for a more noticeable slowdown
      const easeOut = 1 - Math.pow(1 - progress, 4);

      const currentValue = startValue + (parsed.target - startValue) * easeOut;
      statElement.textContent = formatNumber(
        currentValue,
        parsed.suffix,
        parsed.hasPlus
      );

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        // Ensure final value is exact
        statElement.textContent = parsed.original;
      }
    }

    requestAnimationFrame(update);
  }

  // Store original values and parsed data
  const statsData = Array.from(statValues).map((el) => {
    const original = el.textContent.trim();
    const parsed = parseStatValue(original);
    return { element: el, original, parsed };
  });

  // Filter out any that couldn't be parsed
  const validStats = statsData.filter((item) => item.parsed !== null);

  if (validStats.length === 0) {
    return;
  }

  // Set initial values to start percentage immediately (before animation)
  validStats.forEach((item) => {
    const startValue = item.parsed.target * ANIMATION_START_PERCENTAGE;
    item.element.textContent = formatNumber(
      startValue,
      item.parsed.suffix,
      item.parsed.hasPlus
    );
  });

  // Check if IntersectionObserver is available
  if (typeof IntersectionObserver === "undefined") {
    // Fallback: animate immediately
    validStats.forEach((item) => {
      animateStat(item.element, item.parsed);
    });
    return;
  }

  // Track which stats have been animated
  const animatedStats = new Set();

  // Create observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          entry.intersectionRatio > INTERSECTION_THRESHOLD
        ) {
          // Find all stat values within this section
          const sectionStats = entry.target.querySelectorAll(".stat__value");
          sectionStats.forEach((statEl) => {
            if (!animatedStats.has(statEl)) {
              animatedStats.add(statEl);
              const statData = validStats.find((s) => s.element === statEl);
              if (statData) {
                animateStat(statEl, statData.parsed);
              }
            }
          });
        }
      });
    },
    {
      threshold: INTERSECTION_THRESHOLD,
      rootMargin: INTERSECTION_ROOT_MARGIN,
    }
  );

  // Observe the metrics section
  observer.observe(metricsSection);
});
